import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { actionGetUsers, actionDeleteUser, actionSaveUser } from "../actions/UserActions"
import { actionGetRoles } from "../actions/RolActions"
import { actionGetRestaurants } from "../actions/RestaurantActions"
import { LOGIN_ROUTE, USERS_EDIT_ROUTE } from "../config/RoutesConstants"
import { 
  Container, 
  Chip,
  IconButton,
  Button,
  Box, 
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Paper,
  Typography, 
  Fab,
  Toolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  Tooltip,
  Input,
} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from '@material-ui/icons/Add';
import BlockIcon from '@material-ui/icons/Block';
import ActiveIcon from '@material-ui/icons/CheckCircle';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import NotificationIcon from '@material-ui/icons/Notifications';
import Util, { SUCCESS,ERROR } from '../common/Util'
import AssignRolToUser from './users/AssignRolToUser'
import NotifyUser from './users/NotifyUser'
import Roles from "../config/RolesConstants"

class Users extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={page:0, rowPerPage:5, count:0, users:[], filter:"", userForDelete:false, assignRol:false, userSelected:null, isSuperAdmin:false}
    this.renderTableHeader=this.renderTableHeader.bind(this)
    this.renderTableBody=this.renderTableBody.bind(this)
    this.onChangePage=this.onChangePage.bind(this)
    this.onChangeRowsPerPage=this.onChangeRowsPerPage.bind(this)
    this.getDeleteUserSuccess=this.getDeleteUserSuccess.bind(this)
    this.onConfirmDeleteUser=this.onConfirmDeleteUser.bind(this)
    this.onSearch=this.onSearch.bind(this)
    this.onCloseEditUser=this.onCloseEditUser.bind(this)
    this.onNotifyUser=this.onNotifyUser.bind(this)
  }

  componentWillMount(){
    if(this.props.login){
      this.props.actionGetUsers(this.onChangePage, this.getUsersError)
      this.props.actionGetRoles(null, (e)=>{console.log("ERROR AL LISTAR ROLES",e)})
      let isSuperAdmin = this.props.profile&&(this.props.profile.proRoles.findIndex((r)=>{return r.id==Roles.SUPERADMIN})>=0)
      if(isSuperAdmin){
        this.setState({isSuperAdmin:true})
        this.props.actionGetRestaurants(null, (e)=>{console.log("ERROR AL LISTAR COMERCIOS",e)})
      }
    }
  }
0
  getUsersError(e){
    // console.log("ERROR GET USERS", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al listar los usuarios.")
  }

  onSearch(evt){
    this.setState({filter:evt.target.value}, this.onChangePage)
  }

  onChangePage(evt=null, newPage=0){
    let from=newPage*this.state.rowPerPage
    let end=from+this.state.rowPerPage
    let userFilter = this.state.filter
    let users = []
    if(this.state.isSuperAdmin){
      let filter = new RegExp(userFilter,"ig")
      users = this.props.userList.filter((u)=>{return u.proName&&u.proName.match(filter)||u.proLastName&&u.proLastName.match(filter)||u.proEmail&&u.proEmail.match(filter)})
    }else{
      users = this.props.userList.filter((u)=>{return u.proEmail&&u.proEmail==userFilter})
    }
    const count = users.length
    users = users.slice(from, end)
    this.setState({page:newPage, count:count, users:users})
  }

  onChangeRowsPerPage(evt){
    let from=this.state.page*evt.target.value
    let end=from+evt.target.value
    let userFilter = this.state.filter
    let users = []
    if(this.state.isSuperAdmin){
      let filter = new RegExp(userFilter,"ig")
      users = this.props.userList.filter((u)=>{return u.proName&&u.proName.match(filter)||u.proLastName&&u.proLastName.match(filter)||u.proEmail&&u.proEmail.match(filter)})
    }else{
      users = this.props.userList.filter((u)=>{return u.proEmail&&u.proEmail==userFilter})
    }
    const count = users.length
    users = users.slice(from, end)
    this.setState({rowPerPage:evt.target.value, users:users})
  }

  onNotifyUser(user){
    this.setState({notifyUser:true, userSelected:user})
  }

  onBlock(user){
    let canBlock = true
    if(!this.state.isSuperAdmin){
      canBlock = user.proRoles.findIndex((r)=>{return r.id == Roles.SUPERADMIN || r.id == Roles.ADMIN})<0
    }
    if(!canBlock){
      Util.showNoty(ERROR, "No puede activar/desactivar este usuario ")
      return;
    }
    if(user.proStatus=='active'){
      user.proStatus='inactive'
      this.props.actionSaveUser(user, 
        ()=>{
          Util.showNoty(SUCCESS, "Usuario inactivo")
          this.props.actionGetUsers(()=>{this.onChangePage(null,this.state.page)},this.getUsersError)
        },
        (e)=>{
          if(!(e&&e.status&&e.status==401))
            Util.showNoty(ERROR, "No pudimos desactivar el usuario")
        }
      )
    }else{
      user.proStatus='active'
      this.props.actionSaveUser(user, 
        ()=>{
          Util.showNoty(SUCCESS, "Usuario activo")
          this.props.actionGetUsers(()=>{this.onChangePage(null,this.state.page)},this.getUsersError)
        },
        (e)=>{
          if(!(e&&e.status&&e.status==401))
            Util.showNoty(ERROR, "No pudimos activar el usuario")
          }
      )
    }
  }

  onEditUser(user){
    let canEdit = true
    if(!this.state.isSuperAdmin){//Si no soy super admin
      canEdit = !user.proRoles||user.proRoles.findIndex((r)=>{return r.id == Roles.SUPERADMIN || r.id == Roles.ADMIN})<0 //Puedo editar usuarios admin o superAdmin
    }
    if(canEdit){
      this.setState({assignRol:true, userSelected:user})
    }else{
      Util.showNoty(ERROR, "No puede editar este usuario ")
    }
    //this.props.history.push(USERS_EDIT_ROUTE, user)
    
  }

  onCloseEditUser(save){
    this.setState({assignRol:false})
    if(save==SUCCESS){
      this.props.actionGetUsers(()=>{this.onChangePage(null,this.state.page)},this.getUsersError)
    }
    
  }
  
  onDeleteUser(user){
    let canDelete = true
    if(!this.state.isSuperAdmin){
      canDelete = user.proRoles.findIndex((r)=>{return r.id == Roles.SUPERADMIN || r.id == Roles.ADMIN})<0
    }
    if(canDelete){
      this.setState({userForDelete:user})  
    }else{
      Util.showNoty(ERROR, "No puede eliminar este usuario ")
    }
  }

  onConfirmDeleteUser(){
    this.props.actionDeleteUser(this.state.userForDelete,this.getDeleteUserSuccess,this.getDeleteUserError)
    this.setState({userForDelete:false})
  }

  getDeleteUserSuccess(){
    this.props.actionGetUsers(()=>{this.onChangePage(null,this.state.page)}, this.getUsersError)
  }

  getDeleteUserError(e){
    console.log("ERROR", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al elminar el usuario.")
  }

  renderTableHeader(){
    const {theme} = this.props
    const headers = ["Usuario","Apellido y Nombre", "Rol", "Status"]
    return (
    <TableRow>
      {headers.map((label)=>{
        return (
          <TableCell>{label}</TableCell>
        )
      })}
      <TableCell style={theme.table.actionsColumn}>Acciones</TableCell>
    </TableRow>
    )
  }

  renderTableBody(){
    const {theme} = this.props
    let users = this.state.users
    if(!users||users.length==0){
      let emptyText="No se encontraron registros"
      if(!this.state.isSuperAdmin){
        emptyText=this.state.filter?`No se encontraron registros para ${this.state.filter}`:"Debe ingresar el email para buscar el usuario"
      }
      return <Box style={theme.table.empty}>{emptyText}</Box>
    }
    return users.map((item, index)=>{
      let isInactive=item.proStatus&&item.proStatus.toLowerCase() == "inactive"
      return (
        <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
          <TableCell>{item.proEmail}</TableCell>
          <TableCell>{`${item.proLastName}, ${item.proName}`}</TableCell>
          <TableCell>{item.proRoles&&item.proRoles.map((r)=>{
            return <Chip label={r.displayName} color="primary"/>
          })}</TableCell>
          <TableCell style={isInactive?theme.overrides.MuiTableCell.body:theme.table.activeCell}>{isInactive?"INACTIVO":"ACTIVO"}</TableCell>
          <TableCell style={theme.table.actionsColumn}>
            {/* <Tooltip title="Notificar usuario">
              <IconButton onClick={this.onNotifyUser.bind(this,item)}>
                <NotificationIcon/>
              </IconButton>
            </Tooltip> */}
            <Tooltip title="Editar usuario">
              <IconButton onClick={this.onEditUser.bind(this,item)}>
                <EditIcon/>
              </IconButton>
            </Tooltip>
            <Tooltip title={isInactive?"Activar usuario":"Desactivar usuario"}>
              <IconButton onClick={this.onBlock.bind(this, item)}>
                {isInactive?<ActiveIcon/>:<BlockIcon/>}
              </IconButton>
            </Tooltip>
            {this.state.isSuperAdmin&&<Tooltip title="Eliminar usuario">
              <IconButton onClick={this.onDeleteUser.bind(this, item)}>
                <DeleteIcon/>
              </IconButton>
            </Tooltip>
            }
          </TableCell>
        </TableRow>
      )
    })
  }

  render(){
    const { theme, userList } = this.props
    return (
      <Box style={theme.mainContainer}>
        <Box style={theme.title.container}>
          <Typography variant="h1">Usuarios</Typography>
          <Typography variant="subtitle1">Crea usuarios</Typography>
        </Box>
        <Container style={theme.table.container}>        
          <Paper>
            <Typography style={theme.paper.title} variant="h2">Listado de usuarios</Typography>
            <Toolbar style={{...theme.table.toolbar, justifyContent:"flex-end"}} >
                <Input placeholder="Buscar" onChange={this.onSearch}/>
            </Toolbar>
            <Table stickyHeader>
              <TableHead > 
                {this.renderTableHeader()}
              </TableHead>
              <TableBody>
                {this.renderTableBody()}
              </TableBody>
            </Table> 
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={this.state.count}
              rowsPerPage={this.state.rowPerPage}
              page={this.state.page}
              onChangePage={this.onChangePage}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
            />
          </Paper>
          <Dialog open={this.state.userForDelete}>
            <DialogTitle>Eliminar Usuario</DialogTitle>
            <DialogContent>
              <DialogContentText>¿Está seguro que desea eliminar el usuario?</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Tooltip title="Cancelar">
                <Button variant="contained" color="secondary" onClick={()=>{this.setState({userForDelete:null})}}>Cancelar</Button>
              </Tooltip>
              <Tooltip title="Eliminar usuario">  
                <Button variant="contained" color="primary" onClick={this.onConfirmDeleteUser}>Eliminar</Button>
              </Tooltip>  
            </DialogActions>
          </Dialog>
          <AssignRolToUser open={this.state.assignRol} onClose={this.onCloseEditUser} user={this.state.userSelected}/>
          <NotifyUser open={this.state.notifyUser} onClose={()=>{this.setState({notifyUser:false})}} user={this.state.userSelected}/>
        </Container>
      </Box>
    )
  }
}

function mapStateToProps(store) {
  return {
    login: store.auth.login,
    userList: store.usr.userList,
    profile: store.auth.profile

  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetUsers,
      actionGetRoles,
      actionDeleteUser,
      actionSaveUser,
      actionGetRestaurants
    },
    dispatch
  );
}

export default  withRouter(
                  withTheme(
                    connect(
                      mapStateToProps,
                      mapDispatchToProps
                    )(Users)
                  )
                )


// WEBPACK FOOTER //
// ./src/screens/Users.js